import React, { useEffect, useState } from "react";
import "./style.css";
import Ssf from "../../Assets/Images/ssf.png";
import { NavLink } from "react-router-dom";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className={scrolled ? "scrolled-nav" : ""}>
      <div className="navbar">
        <div className="logo">
          <img src={Ssf} alt="Logo" />
        </div>

        {/* Hamburger */}
        <div className="hamburger" onClick={toggleMenu}>
          
          <div></div>
          <div></div>
          <div></div>
        </div>

        {/* Menu */}
        <ul className={`menu ${menuOpen ? "show" : ""}`}>
          <li><NavLink to="/" onClick={() => setMenuOpen(false)} className={({ isActive }) => isActive ? "active" : ""}>Home</NavLink></li>
          <li><NavLink to="/about-us" onClick={() => setMenuOpen(false)} className={({ isActive }) => isActive ? "active" : ""}>About Us</NavLink></li>
          <li><NavLink to="/services" onClick={() => setMenuOpen(false)} className={({ isActive }) => isActive ? "active" : ""}>Services</NavLink></li>
          <li><NavLink to="/awards" onClick={() => setMenuOpen(false)} className={({ isActive }) => isActive ? "active" : ""}>Awards</NavLink></li>
          <li><NavLink to="/contact-us" onClick={() => setMenuOpen(false)} className={({ isActive }) => isActive ? "active" : ""}>Contact Us</NavLink></li>
          <li><NavLink to="/career" onClick={() => setMenuOpen(false)} className={({ isActive }) => isActive ? "active" : ""}>Careers</NavLink></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
